import moment from 'moment'

export function lessThan(value, { length }) {
  return value.length <= parseInt(length);
}
export function greaterThan(value, { length }) {
  return value.length >= parseInt(length);
}
export function validEmail(value) {
  return /\S+@\S+\.\S+/.test(value);
}
export function validNumber(value) {
  if (value.length >= 1) {
    return value >= 0;
  } else {
    return true
  }
}
export function presentOrFuture(value) {
  let today = moment().format('YYYY/MM/DD')
  let diff = moment(value, 'YYYY/MM/DD').diff(
    moment(today, 'YYYY/MM/DD'),
    'days'
  )
  return diff >= 0
}